"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyType = void 0;

/* eslint-disable camelcase */
var PropertyType;
exports.PropertyType = PropertyType;

(function (PropertyType) {
  PropertyType["studio"] = "STUDIO";
  PropertyType["apartment"] = "APARTMENT";
  PropertyType["house"] = "HOUSE";
  PropertyType["building"] = "BUILDING";
  PropertyType["privateRoom"] = "PRIVATE_ROOM";
  PropertyType["sharedRoom"] = "SHARED_ROOM";
  PropertyType["unknown"] = "UNKNOWN";
})(PropertyType || (exports.PropertyType = PropertyType = {}));